<template>
  <v-dialog v-model="u_attendance" max-width="500">
    <v-card v-if="pocket">
      <v-card-title class="text-h5">
        {{ pocket.name }}
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" md="4" lg="4" v-for="(item, i) in list" :key="i">
            <div class="pa-3">
              <v-card
                class="pa-3 d-flex align-center"
                @click="pocket.selected = item.val"
                :color="pocket.selected == item.val ? item.color : ''"
                :dark="pocket.selected == item.val"
                flat
              >
                <v-icon large class="mr-3"> {{ item.icon }} </v-icon>
                <h4 class="text-center">
                  {{ item.key }}
                </h4>
              </v-card>
            </div>
          </v-col>
        </v-row>
        <div class="px-3">
          <v-textarea
            v-model="pocket.notes"
            dense
            color="green"
            placeholder="Notes"
            hide-details="auto"
            outlined
            auto-grow
            counter
            :rules="rules"
          ></v-textarea>
        </div>
        <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
          <v-progress-circular indeterminate class="mr-2"></v-progress-circular>
          <b>Loading...</b>
        </v-overlay>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="$emit('close')">
          Cancel
        </v-btn>

        <v-btn color="green darken-1" text @click="updateData">
          Update Data
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UpdateAttendace",
  props: ["u_attendance", "pocket"],
  data() {
    return {
      loading: false,
      rules: [(v) => v.length <= 225 || "Max 225 characters"],
      list: [
        {
          key: "Present",
          val: "present",
          icon: "mdi-account-check",
          color: "green",
        },
        {
          key: "Permit",
          val: "permit",
          icon: "mdi-account-injury-outline",
          color: "orange",
        },
        {
          key: "Alpha",
          val: "alpha",
          icon: "mdi-account-remove",
          color: "red",
        },
      ],
    };
  },
  methods: {
    updateData() {
      const vm = this;
      vm.loading = true;
      let data = {
        path: `manage/attendance/update-attend`,
        body: {
          course_attendance_id: vm.pocket.course_attendance_id,
          scholar_id: vm.pocket.scholar_id,
          attend: vm.pocket.selected,
          notes: vm.pocket.notes,
        },
      };

      vm.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          vm.loading = false;
          vm.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          vm.$emit("close");
          vm.$emit("fetch");
        })
        .catch((e) => {
          vm.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          vm.loading = false;
        });
    },
  },
};
</script>

<style></style>
